/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaContentObject } from '../../models/criteria-content-object';
import { ImageContent } from '../../models/image-content';

export interface ApiMasterImageContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterImageContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterImageContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ImageContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterImageContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ImageContent>>;
    })
  );
}

apiMasterImageContentGetByCriteriaPost.PATH = '/api/Master/ImageContent/GetByCriteria';
